<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t("AJOUTER_UNE") : $t("MODIFICATION_DE") }} {{$t("HEALTHFACILITY")}}  </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
        <div class="p-6">
          <p class="pt-4">{{ $t("healthFacility_name") }}<b style="color: #ff6141" >*</b> </p>
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="healthFacility"
            v-model="input.name"
            class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('healthFacility')">{{$t("healthFacility_error")}}</span>
          
          <p class="pt-4">{{ $t("healthFacilityType") }}<b style="color: #ff6141">*</b></p>
            <vs-select
                v-model="input.healthFacilityType"
                v-validate="'required'"
                autocomplete
                clearable
                class="w-full "
                name="healthFacilityType"
            >
            <vs-select-item :key="item" :value="item.id" :text="item.name" v-for="item in healthFacilityTypes" /></vs-select>
            <span class="text-danger text-sm" v-show="errors.has('healthFacilityType')">{{$t("healthFacilityType_error")}}</span>
         
            <p class="pt-4">{{ $t("region") }}<b style="color: #ff6141" >*</b> </p>
            <v-select
            v-validate="'required'"
            name="region"
            autocomplete
            clearable
            class="w-full" label="name"
            :reduce="(rep) => rep.id"
            v-model="input.region"
            :options="regions"
            >
            </v-select>
          <span class="text-danger text-sm" v-show="errors.has('region')">{{$t("region_error")}}</span>
          
            <p class="pt-4">{{ $t("address") }}<b style="color: #ff6141" >*</b> </p>
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="address"
            v-model="input.address"
            class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('healthFacility')">{{$t("Address_error")}}</span>

          <p class="pt-4">{{ $t("Phone") }} <b style="color: #ff6141">*</b></p>
          <vue-tel-input
            v-model="input.phoneNumber"
            placeholder="Telephone"
            :mode="national"
            :autoFormat="false"
            :enabledCountryCode="true"
            :enabledFlags="true"
            :validCharactersOnly="true"
            data-vv-validate-on="blur"
            v-validate="'required'"
            @validate="yourValidationMethod"
            name="phoneNumber"
            class="w-full"
          >
          </vue-tel-input>
          <span class="text-danger text-sm" v-show="errors.has('phoneNumber')">{{
            errors.first("phoneNumber")
          }}</span>
        </div>
      </component>
  
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="category_validate">{{$t("Soumettre")}}</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t("Annuler")}}</vs-button>
      </div>
    </vs-sidebar>
  </template>
  
<script>
  
// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    healthFacilityType: {
      required: 'Le champ type de structure sanitaire est obligatoire'
    },
    healthFacility: {
      required: 'Le champ structure sanitaire est obligatoire'
    },
    phoneNumber: {
      required: 'Le champ téléphone est obligatoire',
      min: 'Au minimum 20 caractères.',
      max: 'Au minimum 20 caractères.'
    },
    address: {
      required: 'Le champ l\'adresse est obligatoire'
    }
  }
}
  
// register custom messages
Validator.localize('en', dict)
  
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  
const input_tempon = {
  name: '',
  healthFacilityType: '',
  address: '',
  phoneNumber: '',
  region:''
}
  
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      healthFacilityTypes: [],
      regions:[],
      input: JSON.parse(JSON.stringify(input_tempon)),
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        this.input = JSON.parse(JSON.stringify(this.data))
        this.input.healthFacilityType = this.data.healthFacilityType.id
        this.input.region = this.data.region.id

        this.initValues()
      }
    }
  },
  
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.input = JSON.parse(JSON.stringify(input_tempon))
    },
    category_validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitData()
        }
      })
    },
  
    async submitData () {
      this.$vs.loading()
      const input = JSON.parse(JSON.stringify(this.input))
  
      let url = 'all-healthFacilities/'
      let methods = 'post'
      const message = {
        error: this.$t('save_error'),
        success: this.$t('healthFacility_save')
      }
      if (input.id) {
        url += `${input.id}/`
        methods = 'put'
        message.success = this.$t('healthFacility_update')
      }
  
      this.$http[methods](url, input)
        .then((response) => {
          window.healthFacilities.getAllhealthFacilities()
          window.getPrendTaCom.success(message.success, response)
          this.$emit('closeSidebar')
          this.initValues()
        })
        .catch((error) => {
  
          const clefs = Object.keys(error.response.data)
          for (let i = 0; i < clefs.length; i++) {
            const item = clefs[i]
            let libelle = ''
            if (item === 'name') {
              libelle = this.$t('name')
            }
            if (item === 'healthFacilityType') {
              libelle = this.$t('healthFacilityType')
            }
            if (item === 'phoneNumber') {
              libelle = this.$t('phoneNumber')
            }
            if (item === 'address') {
              libelle = this.$t('address')
            }
            if (item === 'region') {
              libelle = this.$t('region')
            }
            for (let j = 0; j < error.response.data[item].length; j++) {
              window.getPrendTaCom.error(`${libelle} :  ${error.response.data[item][j]}`)
            }
          }
  
          window.getPrendTaCom.error(message.error)
        })
    },
    getAllregions () {
      this.$vs.loading()
      this.$http.get('regions/')
        .then((response) => {
          this.regions = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getAllhealthFacilityTypes () {
      this.$vs.loading()
      this.$http.get('healthFacilityTypes/')
        .then((response) => {
          this.healthFacilityTypes = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  
  },
  created () {
    this.getAllhealthFacilityTypes()
    this.getAllregions()

  }
}
</script>
  
  <style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }
  
    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
  
      .img-upload {
        margin-top: 2rem;
  
        .con-img-upload {
          padding: 0;
        }
  
        .con-²-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  
  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  
    &:not(.ps) {
      overflow-y: auto;
    }
  }
  </style>
  